import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import moment from "moment"
import Modal from 'react-bootstrap/Modal';
import quizimage from '../../../../assets/images/quizimage.svg'
import NoQuizFound from '../../NoData/NoQuizFound';
import quizimg1 from '../../../../assets/images/new/quizone.png'
import quizimg2 from '../../../../assets/images/new/quiztwo.png'
import ProQuizImage from '../../../../assets/images/pro/ProQuiz.png'

const UserQuiz = ({ setShowTab , qusList2D=[], UUID2D=null, update2DQuizSession}) => {
    const params = useParams();
    const moduleUUID = params?.uuid;
    const userData = useSelector(state => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    let MODE = configData.config.MODE;
    const [showBanner, setShowBanner] = useState(true);
    const [showQuiz, setShowQuiz] = useState(false)
    const [showModal, setShowModal] = useState(false);

    const [currentIndex, setCurrentIndex] = useState(0);
    const [attemptedList, setAttemptedList] = useState([]);
    const [chooseAnswerList, setChooseAnswerList] = useState([]);
    const [userPlan, setUserPlan] = useState(null);
    const [qusList, setQusList] = useState([]);
    const [playedList, setPlayedList] = useState([]);
    const[quizSubmitLoading,setSubmitQuizLoading]=useState(false);

    useEffect(() => {
        userData?.plans?.data && setUserPlan(userData.plans.data);
      }, [userData]);

    const getXrQuestionList = async () => {
        try {
          const response = await axios.get(`${configData.config.UNO_URL}/api/user/play/quiz/${moduleUUID}`, {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            }
          });
    
          let qusData = response?.data?.quiz;
    
          const shuffleArray = (array) => {
            for (let i = array?.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [array[i], array[j]] = [array[j], array[i]];
            }
          }
          shuffleArray(qusData);

          qusData.forEach((item) => {
            if (item.options) {
              shuffleArray(item.options);
            }
          });

          setQusList([...qusData]);
          if(qusData.length > 0) setShowTab();
    
        } catch (error) {
          console.log(error);
        }
      }

    const getXrPlayedQuizList = async (uuid) => {
        try {
    
          let response = await axios.get(`${configData.config.API_URL}/api/quiz/getPlayedList/${uuid}`, {
            headers: {
              Authorization: `Bearer ${userData.token}`,
              "Content-Type": "application/json"
            }
          });
          let listData = response?.data?.list || [];
          setPlayedList([...listData]);
        } catch (error) {
          console.log(error);
        }
    
      };

    useEffect(()=>{
        if(moduleUUID.length && MODE === "XR"){
            getXrQuestionList(moduleUUID);
            getXrPlayedQuizList(moduleUUID);
        }
    },[moduleUUID]);
    
    useEffect(()=>{
        if(UUID2D && MODE === "2D"){
          if(qusList2D && qusList2D.length){
                setQusList(qusList2D);
            }
            getXrPlayedQuizList(UUID2D);
        }
    },[qusList2D, UUID2D]);

    useEffect(() => {
        if (playedList?.length > 0) {
            setAttemptedList([...playedList]);
        }

    },[playedList]);


    const handleChooseOption = (answerId, qId, quesType) => {
        let found = false;
        let allAttempt = chooseAnswerList
        let newData = {
            answerId,
            qId,
            quesType
        }

        for (let i = 0; i < allAttempt?.length; i++) {
            if (allAttempt[i].qId === newData.qId) {
                allAttempt[i] = newData;
                found = true;
                break;
            }
        }

        if (!found) {
            allAttempt.push(newData);
        }
        setChooseAnswerList([...allAttempt]);
    };

    const gotoNextQus = (cI) => {
        setCurrentIndex(cI);
    }
    const gotoPrevQus = (CI) => {
        setCurrentIndex(CI);
    }

        // Throttle function implementation
    const debounce = (func, delay) => {
            let timer;
            return function (...args) {
                clearTimeout(timer);
                timer = setTimeout(() => func.apply(this, args), delay);
            };
        };

    const finalSubmit = async () => {
        setSubmitQuizLoading(true);
        let uuid = MODE === "2D" ? UUID2D : moduleUUID;
        try {
            let _bodyData = {ansData: [...chooseAnswerList] }

            let {data} = await axios.post(`${configData.config.API_URL}/api/quiz/save/${MODE}/${uuid}`, _bodyData, {
                headers: {
                    Authorization: `Bearer ${userData.token}`,
                    "Content-Type": "application/json"
                }
            });
            
            if(MODE === "2D"){
                update2DQuizSession({
                    "totalWeightAge": data.data.totalWeightAge,
                    "totalRightWeightAge": data.data.totalRightWeightAge
                });
            }

            setCurrentIndex(0);
            setChooseAnswerList([]);
            setShowQuiz(false);
            setShowModal(false);
            getXrPlayedQuizList(uuid);

        } catch (error) {
            console.log(error);
        }finally{
            setSubmitQuizLoading(false);
        }

    }

    const debouncedFinalSubmit = debounce(finalSubmit, 1000); // Debounce for 1 second
    const confirmFinalSubmit = () => setShowModal(true);

    return (
        <>
        <div  className= {MODE === "XR" ? 'container' : "w-100" }>

        { userPlan?.courseDetail?.quiz ? 
            <div className="quiz main-quiz-body">
                    <div className='reattempt-body'>
                        {showBanner ?
                            <div className='firsttimeuserinquiz mt-2'>
                                        <div className='quiztextfg'>
                                                    {qusList?.length > 0 ?
                                                        <>
                                                            <div className="quiz-start-page">
                                                                <h6>Take this Quiz to <br /> complete your learning journey.</h6>
                                                                <p>Try your hand at all <span className='text-danger'>{qusList?.length} questions</span> to find out your score   </p>
                                                                <p>Best of Luck!</p>
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <button onClick={() => { setShowBanner(false); setShowQuiz(true) }} className='DefaultRedBtn'>Start Quiz</button>
                                                                    {attemptedList.length > 0 && <a className='attemptedlistss ms-2 cursor-pointer'> <span onClick={() => { setShowBanner(false); setShowQuiz(false) }}>Attempted List</span> </a>}
                                                                </div>
                                                            </div>
                                                            <img className='quiz-que-img' src={quizimage} alt="" />
                                                        </>
                                                        :
                                                        <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                                                        <NoQuizFound />
                                                        </div>
                                                    }
                                             
                                          
                                        </div>
                            </div>
                            :
                            showQuiz ?
                                <div className='questiondiv'>
                                    {qusList?.length > 0 ?
                                        <>
                                            <div className='questiondiv'>
                                                <img src={quizimg1} className='quizimg1' alt="" />
                                                <h5>Question {currentIndex + 1}/{qusList?.length}</h5>
                                                {qusList.map((e, index) => {
                                                    if (currentIndex != index) return;
                                                    let selectedAns = chooseAnswerList.filter((d) => d.qId == e.id)[0]?.answerId ?? null;
                                                    return (
                                                        <div className="row justify-content-center" key={index + 1} >
                                                            <div className="col-md-8">
                                                               
                                                                    <h6> {e.question} </h6>
                                                              
                                                                <div className="row justify-content-center mt-4">
                                                                    <div className="col-md-8">
                                                                        <ul className='answerlist'>
                                                                            {e.options.map((f, i) => (
                                                                                <li
                                                                                    key={i}
                                                                                    className={selectedAns === f.id ? 'active' : ''}
                                                                                    onClick={() => handleChooseOption(f.id, e.id, e.quesType)}
                                                                                >
                                                                                    <span>{String.fromCharCode(65 + i)}</span> {f.name}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
    
                                                                <div className="mt-3 text-center">
                                                                    {qusList?.length === chooseAnswerList?.length && currentIndex < qusList.length - 1 ? (
                                                                        <>
                                                                            <button disabled={currentIndex === 0} className="btn btn-outline-danger mx-1" onClick={() => gotoPrevQus(currentIndex - 1)}>
                                                                                Prev
                                                                            </button>
                                                                            <button className="btn btn-outline-danger mx-1" onClick={() => gotoNextQus(currentIndex + 1)}>
                                                                                Next
                                                                            </button>
                                                                        </>
                                                                    ) : currentIndex === qusList.length - 1 ? (
                                                                        <>
                                                                            <button disabled={currentIndex === 0} className="btn btn-outline-danger mx-1" onClick={() => gotoPrevQus(currentIndex - 1)}>
                                                                                Prev
                                                                            </button>
                                                                            <button disabled={chooseAnswerList.length === 0} className="btn btn-danger mx-1" onClick={confirmFinalSubmit}>
                                                                                Submit
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <button disabled={currentIndex === 0} className="btn btn-outline-danger mx-1" onClick={() => gotoPrevQus(currentIndex - 1)}>
                                                                                Prev
                                                                            </button>
                                                                            <button className="btn btn-outline-danger mx-1" onClick={() => gotoNextQus(currentIndex + 1)}>
                                                                                Next
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </div>
    
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <img src={quizimg2} className='quizimg2' alt="" />
                                            </div>
                                        </>
                                        :
                                        <p>No Quiz Found. </p>
                                    }
                                </div>
                                :
                                <div className="attemptedlist">
                                    <div className="reattemptbosddd">
                                        <div className="row align-items-center">
                                            <div className="col-md-2">
                                                <img src={quizimage} className='img-fluid' alt="" />
                                            </div>
                                            <div className="col-md-6">
                                                <h6 className='text-danger'>Let's get Started!</h6>
                                                <p className='mb-1'>Try your hand at all <span className='text-danger'>{qusList?.length} questions</span> to find out your score   </p>
                                                 {attemptedList.length &&  <p className='mb-2'>Last Score: <span className='text-danger'>{ attemptedList[0].achieve}/{attemptedList[0].total }</span> </p> }
                                                <div className="d-flex align-items-center">
                                                    <button className='btn btn-danger' onClick={() => setShowQuiz(true)}>Reattempt Quiz</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-md-12 table-responsive workflowtb stickyhead " style={{ width:"98%" }}>
                                            <table className="table table-hover leaderboardtable">
                                                <thead>
                                                    <tr>
                                                        <th>Attempt No.</th>
                                                        <th>Score</th>
                                                        <th>Percentage</th>
                                                        <th style={{ width: '250px' }}>Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {attemptedList.map((e, index) => {
                                                        return (
                                                            <tr key={index + 1}>
                                                                <td> Attempt : {attemptedList.length - index} </td>
                                                                <td>{e.achieve}/{e.total}</td>
                                                                <td>
                                                                    <div className='d-flex align-items-center w-80 pe-5'>
                                                                        <div className="progress w-100">
                                                                            <div className="progress-bar" role="progressbar" style={{ width: (e.achieve / e.total) * 100 + "%" }} aria-valuenow={`${(e.achieve / e.total) * 100}`} aria-valuemin="0" aria-valuemax="100"></div>
                                                                        </div>
                                                                        <p className='mb-0 ps-2' style={{ width: '60px' }}> 
                                                                        {Math.round((e.achieve / e.total) * 100 * 100) / 100}%
                                                                         </p>
                                                                    </div>
                                                                </td>
                                                                <td>{moment(e?.createdAt).format('DD-MM-YYYY')} at  {moment(e?.createdAt).format('h:mm a')}  </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                        }
    
                    </div>
            </div >
                :
            <div className='for-pro' style={{ aspectRatio:"auto" }}>
                <img src={ProQuizImage}/>
                <span className='cover-up'>

                </span>
                <div className='unlock-data'>
                    <h6>Unlock Features</h6>
                    <p>To access these additional features, <br/>
                    please <a> upgrade you plan. </a>
                    </p>
                    <button>Upgrade Plan</button>
                </div>
            </div>
        }

        </div>

        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Quiz Submitted</Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center'>
                <h5>
                    You attempted<span className='text-danger'> {chooseAnswerList.length}/{qusList.length}</span> questions. <br />
                    Do you want to submit the quiz?
                </h5>

                <div className='text-center mt-3'>
                    <button onClick={() => setShowModal(false)} className='btn btn-outline-danger'>Cancel</button>
                    {
                        quizSubmitLoading?  <button className="btn btn-danger mx-2" > Submiting </button>
                        :
                         <button className="btn btn-danger mx-2" onClick={() => finalSubmit()}> Submit </button>
                    }
                </div>
            </Modal.Body>
        </Modal>

        </>
    );
};

export default UserQuiz;
